/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfServiceImport } from './routes/terms-of-service'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SignInImport } from './routes/sign-in'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as PricingImport } from './routes/pricing'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as DeleteAccountImport } from './routes/delete-account'
import { Route as ChangePasswordImport } from './routes/change-password'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app.index'
import { Route as AppSettingsImport } from './routes/_app.settings'
import { Route as AppImportImport } from './routes/_app.import'
import { Route as AppDashboardImport } from './routes/_app._dashboard'
import { Route as AppCasesIndexImport } from './routes/_app.cases.index'
import { Route as AppApplicantsIndexImport } from './routes/_app.applicants.index'
import { Route as ClientPortalPublicEncodedCaseIdImport } from './routes/client-portal.public.$encodedCaseId'
import { Route as ClientPortalInternalSampleImport } from './routes/client-portal.internal.sample'
import { Route as AppCasesInactiveImport } from './routes/_app.cases.inactive'
import { Route as AppCasesActiveImport } from './routes/_app.cases.active'
import { Route as AppCasesEoirInactiveImport } from './routes/_app.cases-eoir.inactive'
import { Route as AppCasesEoirActiveImport } from './routes/_app.cases-eoir.active'
import { Route as AppApplicantsApplicantIdImport } from './routes/_app.applicants.$applicantId'
import { Route as AppDashboardDashboardIndexImport } from './routes/_app._dashboard.dashboard.index'
import { Route as ClientPortalInternalApplicantIdCaseIdImport } from './routes/client-portal.internal.$applicantId.$caseId'
import { Route as ClientPortalEoirPublicEncodedCaseIdImport } from './routes/client-portal.eoir.public.$encodedCaseId'
import { Route as ClientPortalEoirInternalSampleImport } from './routes/client-portal.eoir.internal.sample'
import { Route as AppDashboardDashboardGeneralInfoImport } from './routes/_app._dashboard.dashboard.general-info'
import { Route as AppDashboardDashboardCaseAnalysisImport } from './routes/_app._dashboard.dashboard.case-analysis'
import { Route as AppDashboardDashboardTaskManagementImport } from './routes/_app._dashboard.dashboard._taskManagement'
import { Route as AppDashboardDashboardCaseUpdatesImport } from './routes/_app._dashboard.dashboard._caseUpdates'
import { Route as ClientPortalEoirInternalApplicantIdCaseIdImport } from './routes/client-portal.eoir.internal.$applicantId.$caseId'
import { Route as AppApplicantsApplicantIdCasesCaseNumberImport } from './routes/_app.applicants.$applicantId.cases.$caseNumber'
import { Route as AppApplicantsApplicantIdCasesEoirCaseNumberImport } from './routes/_app.applicants.$applicantId.cases-eoir.$caseNumber'
import { Route as AppDashboardDashboardTaskManagementTaskManagementIndexImport } from './routes/_app._dashboard.dashboard._taskManagement.task-management.index'
import { Route as AppDashboardDashboardCaseUpdatesCaseUpdatesIndexImport } from './routes/_app._dashboard.dashboard._caseUpdates.case-updates.index'
import { Route as AppDashboardDashboardTaskManagementTaskManagementActionRequiredImport } from './routes/_app._dashboard.dashboard._taskManagement.task-management.action-required'
import { Route as AppDashboardDashboardTaskManagementTaskManagementActionCompletedImport } from './routes/_app._dashboard.dashboard._taskManagement.task-management.action-completed'
import { Route as AppDashboardDashboardCaseUpdatesCaseUpdatesCaseUpdateHistoryImport } from './routes/_app._dashboard.dashboard._caseUpdates.case-updates.case-update-history'
import { Route as AppDashboardDashboardCaseUpdatesCaseUpdatesCaseActivityHistoryImport } from './routes/_app._dashboard.dashboard._caseUpdates.case-updates.case-activity-history'

// Create Virtual Routes

const AppDashboardDashboardImport = createFileRoute(
  '/_app/_dashboard/dashboard',
)()

// Create/Update Routes

const TermsOfServiceRoute = TermsOfServiceImport.update({
  path: '/terms-of-service',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SignInRoute = SignInImport.update({
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const PricingRoute = PricingImport.update({
  path: '/pricing',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const DeleteAccountRoute = DeleteAccountImport.update({
  path: '/delete-account',
  getParentRoute: () => rootRoute,
} as any)

const ChangePasswordRoute = ChangePasswordImport.update({
  path: '/change-password',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsRoute = AppSettingsImport.update({
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppImportRoute = AppImportImport.update({
  path: '/import',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardDashboardRoute = AppDashboardDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AppDashboardRoute,
} as any)

const AppCasesIndexRoute = AppCasesIndexImport.update({
  path: '/cases/',
  getParentRoute: () => AppRoute,
} as any)

const AppApplicantsIndexRoute = AppApplicantsIndexImport.update({
  path: '/applicants/',
  getParentRoute: () => AppRoute,
} as any)

const ClientPortalPublicEncodedCaseIdRoute =
  ClientPortalPublicEncodedCaseIdImport.update({
    path: '/client-portal/public/$encodedCaseId',
    getParentRoute: () => rootRoute,
  } as any)

const ClientPortalInternalSampleRoute = ClientPortalInternalSampleImport.update(
  {
    path: '/client-portal/internal/sample',
    getParentRoute: () => rootRoute,
  } as any,
)

const AppCasesInactiveRoute = AppCasesInactiveImport.update({
  path: '/cases/inactive',
  getParentRoute: () => AppRoute,
} as any)

const AppCasesActiveRoute = AppCasesActiveImport.update({
  path: '/cases/active',
  getParentRoute: () => AppRoute,
} as any)

const AppCasesEoirInactiveRoute = AppCasesEoirInactiveImport.update({
  path: '/cases-eoir/inactive',
  getParentRoute: () => AppRoute,
} as any)

const AppCasesEoirActiveRoute = AppCasesEoirActiveImport.update({
  path: '/cases-eoir/active',
  getParentRoute: () => AppRoute,
} as any)

const AppApplicantsApplicantIdRoute = AppApplicantsApplicantIdImport.update({
  path: '/applicants/$applicantId',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardDashboardIndexRoute = AppDashboardDashboardIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AppDashboardDashboardRoute,
  } as any,
)

const ClientPortalInternalApplicantIdCaseIdRoute =
  ClientPortalInternalApplicantIdCaseIdImport.update({
    path: '/client-portal/internal/$applicantId/$caseId',
    getParentRoute: () => rootRoute,
  } as any)

const ClientPortalEoirPublicEncodedCaseIdRoute =
  ClientPortalEoirPublicEncodedCaseIdImport.update({
    path: '/client-portal/eoir/public/$encodedCaseId',
    getParentRoute: () => rootRoute,
  } as any)

const ClientPortalEoirInternalSampleRoute =
  ClientPortalEoirInternalSampleImport.update({
    path: '/client-portal/eoir/internal/sample',
    getParentRoute: () => rootRoute,
  } as any)

const AppDashboardDashboardGeneralInfoRoute =
  AppDashboardDashboardGeneralInfoImport.update({
    path: '/general-info',
    getParentRoute: () => AppDashboardDashboardRoute,
  } as any)

const AppDashboardDashboardCaseAnalysisRoute =
  AppDashboardDashboardCaseAnalysisImport.update({
    path: '/case-analysis',
    getParentRoute: () => AppDashboardDashboardRoute,
  } as any)

const AppDashboardDashboardTaskManagementRoute =
  AppDashboardDashboardTaskManagementImport.update({
    id: '/_taskManagement',
    getParentRoute: () => AppDashboardDashboardRoute,
  } as any)

const AppDashboardDashboardCaseUpdatesRoute =
  AppDashboardDashboardCaseUpdatesImport.update({
    id: '/_caseUpdates',
    getParentRoute: () => AppDashboardDashboardRoute,
  } as any)

const ClientPortalEoirInternalApplicantIdCaseIdRoute =
  ClientPortalEoirInternalApplicantIdCaseIdImport.update({
    path: '/client-portal/eoir/internal/$applicantId/$caseId',
    getParentRoute: () => rootRoute,
  } as any)

const AppApplicantsApplicantIdCasesCaseNumberRoute =
  AppApplicantsApplicantIdCasesCaseNumberImport.update({
    path: '/cases/$caseNumber',
    getParentRoute: () => AppApplicantsApplicantIdRoute,
  } as any)

const AppApplicantsApplicantIdCasesEoirCaseNumberRoute =
  AppApplicantsApplicantIdCasesEoirCaseNumberImport.update({
    path: '/cases-eoir/$caseNumber',
    getParentRoute: () => AppApplicantsApplicantIdRoute,
  } as any)

const AppDashboardDashboardTaskManagementTaskManagementIndexRoute =
  AppDashboardDashboardTaskManagementTaskManagementIndexImport.update({
    path: '/task-management/',
    getParentRoute: () => AppDashboardDashboardTaskManagementRoute,
  } as any)

const AppDashboardDashboardCaseUpdatesCaseUpdatesIndexRoute =
  AppDashboardDashboardCaseUpdatesCaseUpdatesIndexImport.update({
    path: '/case-updates/',
    getParentRoute: () => AppDashboardDashboardCaseUpdatesRoute,
  } as any)

const AppDashboardDashboardTaskManagementTaskManagementActionRequiredRoute =
  AppDashboardDashboardTaskManagementTaskManagementActionRequiredImport.update({
    path: '/task-management/action-required',
    getParentRoute: () => AppDashboardDashboardTaskManagementRoute,
  } as any)

const AppDashboardDashboardTaskManagementTaskManagementActionCompletedRoute =
  AppDashboardDashboardTaskManagementTaskManagementActionCompletedImport.update(
    {
      path: '/task-management/action-completed',
      getParentRoute: () => AppDashboardDashboardTaskManagementRoute,
    } as any,
  )

const AppDashboardDashboardCaseUpdatesCaseUpdatesCaseUpdateHistoryRoute =
  AppDashboardDashboardCaseUpdatesCaseUpdatesCaseUpdateHistoryImport.update({
    path: '/case-updates/case-update-history',
    getParentRoute: () => AppDashboardDashboardCaseUpdatesRoute,
  } as any)

const AppDashboardDashboardCaseUpdatesCaseUpdatesCaseActivityHistoryRoute =
  AppDashboardDashboardCaseUpdatesCaseUpdatesCaseActivityHistoryImport.update({
    path: '/case-updates/case-activity-history',
    getParentRoute: () => AppDashboardDashboardCaseUpdatesRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordImport
      parentRoute: typeof rootRoute
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceImport
      parentRoute: typeof rootRoute
    }
    '/_app/_dashboard': {
      id: '/_app/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/import': {
      id: '/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AppImportImport
      parentRoute: typeof AppImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/applicants/$applicantId': {
      id: '/_app/applicants/$applicantId'
      path: '/applicants/$applicantId'
      fullPath: '/applicants/$applicantId'
      preLoaderRoute: typeof AppApplicantsApplicantIdImport
      parentRoute: typeof AppImport
    }
    '/_app/cases-eoir/active': {
      id: '/_app/cases-eoir/active'
      path: '/cases-eoir/active'
      fullPath: '/cases-eoir/active'
      preLoaderRoute: typeof AppCasesEoirActiveImport
      parentRoute: typeof AppImport
    }
    '/_app/cases-eoir/inactive': {
      id: '/_app/cases-eoir/inactive'
      path: '/cases-eoir/inactive'
      fullPath: '/cases-eoir/inactive'
      preLoaderRoute: typeof AppCasesEoirInactiveImport
      parentRoute: typeof AppImport
    }
    '/_app/cases/active': {
      id: '/_app/cases/active'
      path: '/cases/active'
      fullPath: '/cases/active'
      preLoaderRoute: typeof AppCasesActiveImport
      parentRoute: typeof AppImport
    }
    '/_app/cases/inactive': {
      id: '/_app/cases/inactive'
      path: '/cases/inactive'
      fullPath: '/cases/inactive'
      preLoaderRoute: typeof AppCasesInactiveImport
      parentRoute: typeof AppImport
    }
    '/client-portal/internal/sample': {
      id: '/client-portal/internal/sample'
      path: '/client-portal/internal/sample'
      fullPath: '/client-portal/internal/sample'
      preLoaderRoute: typeof ClientPortalInternalSampleImport
      parentRoute: typeof rootRoute
    }
    '/client-portal/public/$encodedCaseId': {
      id: '/client-portal/public/$encodedCaseId'
      path: '/client-portal/public/$encodedCaseId'
      fullPath: '/client-portal/public/$encodedCaseId'
      preLoaderRoute: typeof ClientPortalPublicEncodedCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/_app/applicants/': {
      id: '/_app/applicants/'
      path: '/applicants'
      fullPath: '/applicants'
      preLoaderRoute: typeof AppApplicantsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof AppCasesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/_dashboard/dashboard': {
      id: '/_app/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardDashboardImport
      parentRoute: typeof AppDashboardImport
    }
    '/_app/_dashboard/dashboard/_caseUpdates': {
      id: '/_app/_dashboard/dashboard/_caseUpdates'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardDashboardCaseUpdatesImport
      parentRoute: typeof AppDashboardDashboardRoute
    }
    '/_app/_dashboard/dashboard/_taskManagement': {
      id: '/_app/_dashboard/dashboard/_taskManagement'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardDashboardTaskManagementImport
      parentRoute: typeof AppDashboardDashboardImport
    }
    '/_app/_dashboard/dashboard/case-analysis': {
      id: '/_app/_dashboard/dashboard/case-analysis'
      path: '/case-analysis'
      fullPath: '/dashboard/case-analysis'
      preLoaderRoute: typeof AppDashboardDashboardCaseAnalysisImport
      parentRoute: typeof AppDashboardDashboardImport
    }
    '/_app/_dashboard/dashboard/general-info': {
      id: '/_app/_dashboard/dashboard/general-info'
      path: '/general-info'
      fullPath: '/dashboard/general-info'
      preLoaderRoute: typeof AppDashboardDashboardGeneralInfoImport
      parentRoute: typeof AppDashboardDashboardImport
    }
    '/client-portal/eoir/internal/sample': {
      id: '/client-portal/eoir/internal/sample'
      path: '/client-portal/eoir/internal/sample'
      fullPath: '/client-portal/eoir/internal/sample'
      preLoaderRoute: typeof ClientPortalEoirInternalSampleImport
      parentRoute: typeof rootRoute
    }
    '/client-portal/eoir/public/$encodedCaseId': {
      id: '/client-portal/eoir/public/$encodedCaseId'
      path: '/client-portal/eoir/public/$encodedCaseId'
      fullPath: '/client-portal/eoir/public/$encodedCaseId'
      preLoaderRoute: typeof ClientPortalEoirPublicEncodedCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/client-portal/internal/$applicantId/$caseId': {
      id: '/client-portal/internal/$applicantId/$caseId'
      path: '/client-portal/internal/$applicantId/$caseId'
      fullPath: '/client-portal/internal/$applicantId/$caseId'
      preLoaderRoute: typeof ClientPortalInternalApplicantIdCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/_app/_dashboard/dashboard/': {
      id: '/_app/_dashboard/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardDashboardIndexImport
      parentRoute: typeof AppDashboardDashboardImport
    }
    '/_app/applicants/$applicantId/cases-eoir/$caseNumber': {
      id: '/_app/applicants/$applicantId/cases-eoir/$caseNumber'
      path: '/cases-eoir/$caseNumber'
      fullPath: '/applicants/$applicantId/cases-eoir/$caseNumber'
      preLoaderRoute: typeof AppApplicantsApplicantIdCasesEoirCaseNumberImport
      parentRoute: typeof AppApplicantsApplicantIdImport
    }
    '/_app/applicants/$applicantId/cases/$caseNumber': {
      id: '/_app/applicants/$applicantId/cases/$caseNumber'
      path: '/cases/$caseNumber'
      fullPath: '/applicants/$applicantId/cases/$caseNumber'
      preLoaderRoute: typeof AppApplicantsApplicantIdCasesCaseNumberImport
      parentRoute: typeof AppApplicantsApplicantIdImport
    }
    '/client-portal/eoir/internal/$applicantId/$caseId': {
      id: '/client-portal/eoir/internal/$applicantId/$caseId'
      path: '/client-portal/eoir/internal/$applicantId/$caseId'
      fullPath: '/client-portal/eoir/internal/$applicantId/$caseId'
      preLoaderRoute: typeof ClientPortalEoirInternalApplicantIdCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-activity-history': {
      id: '/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-activity-history'
      path: '/case-updates/case-activity-history'
      fullPath: '/dashboard/case-updates/case-activity-history'
      preLoaderRoute: typeof AppDashboardDashboardCaseUpdatesCaseUpdatesCaseActivityHistoryImport
      parentRoute: typeof AppDashboardDashboardCaseUpdatesImport
    }
    '/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-update-history': {
      id: '/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-update-history'
      path: '/case-updates/case-update-history'
      fullPath: '/dashboard/case-updates/case-update-history'
      preLoaderRoute: typeof AppDashboardDashboardCaseUpdatesCaseUpdatesCaseUpdateHistoryImport
      parentRoute: typeof AppDashboardDashboardCaseUpdatesImport
    }
    '/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed': {
      id: '/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed'
      path: '/task-management/action-completed'
      fullPath: '/dashboard/task-management/action-completed'
      preLoaderRoute: typeof AppDashboardDashboardTaskManagementTaskManagementActionCompletedImport
      parentRoute: typeof AppDashboardDashboardTaskManagementImport
    }
    '/_app/_dashboard/dashboard/_taskManagement/task-management/action-required': {
      id: '/_app/_dashboard/dashboard/_taskManagement/task-management/action-required'
      path: '/task-management/action-required'
      fullPath: '/dashboard/task-management/action-required'
      preLoaderRoute: typeof AppDashboardDashboardTaskManagementTaskManagementActionRequiredImport
      parentRoute: typeof AppDashboardDashboardTaskManagementImport
    }
    '/_app/_dashboard/dashboard/_caseUpdates/case-updates/': {
      id: '/_app/_dashboard/dashboard/_caseUpdates/case-updates/'
      path: '/case-updates'
      fullPath: '/dashboard/case-updates'
      preLoaderRoute: typeof AppDashboardDashboardCaseUpdatesCaseUpdatesIndexImport
      parentRoute: typeof AppDashboardDashboardCaseUpdatesImport
    }
    '/_app/_dashboard/dashboard/_taskManagement/task-management/': {
      id: '/_app/_dashboard/dashboard/_taskManagement/task-management/'
      path: '/task-management'
      fullPath: '/dashboard/task-management'
      preLoaderRoute: typeof AppDashboardDashboardTaskManagementTaskManagementIndexImport
      parentRoute: typeof AppDashboardDashboardTaskManagementImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  AppRoute: AppRoute.addChildren({
    AppDashboardRoute: AppDashboardRoute.addChildren({
      AppDashboardDashboardRoute: AppDashboardDashboardRoute.addChildren({
        AppDashboardDashboardCaseUpdatesRoute:
          AppDashboardDashboardCaseUpdatesRoute.addChildren({
            AppDashboardDashboardCaseUpdatesCaseUpdatesCaseActivityHistoryRoute,
            AppDashboardDashboardCaseUpdatesCaseUpdatesCaseUpdateHistoryRoute,
            AppDashboardDashboardCaseUpdatesCaseUpdatesIndexRoute,
          }),
        AppDashboardDashboardTaskManagementRoute:
          AppDashboardDashboardTaskManagementRoute.addChildren({
            AppDashboardDashboardTaskManagementTaskManagementActionCompletedRoute,
            AppDashboardDashboardTaskManagementTaskManagementActionRequiredRoute,
            AppDashboardDashboardTaskManagementTaskManagementIndexRoute,
          }),
        AppDashboardDashboardCaseAnalysisRoute,
        AppDashboardDashboardGeneralInfoRoute,
        AppDashboardDashboardIndexRoute,
      }),
    }),
    AppImportRoute,
    AppSettingsRoute,
    AppIndexRoute,
    AppApplicantsApplicantIdRoute: AppApplicantsApplicantIdRoute.addChildren({
      AppApplicantsApplicantIdCasesEoirCaseNumberRoute,
      AppApplicantsApplicantIdCasesCaseNumberRoute,
    }),
    AppCasesEoirActiveRoute,
    AppCasesEoirInactiveRoute,
    AppCasesActiveRoute,
    AppCasesInactiveRoute,
    AppApplicantsIndexRoute,
    AppCasesIndexRoute,
  }),
  ChangePasswordRoute,
  DeleteAccountRoute,
  ForgotPasswordRoute,
  PricingRoute,
  PrivacyPolicyRoute,
  ResetPasswordRoute,
  SignInRoute,
  SignUpRoute,
  TermsOfServiceRoute,
  ClientPortalInternalSampleRoute,
  ClientPortalPublicEncodedCaseIdRoute,
  ClientPortalEoirInternalSampleRoute,
  ClientPortalEoirPublicEncodedCaseIdRoute,
  ClientPortalInternalApplicantIdCaseIdRoute,
  ClientPortalEoirInternalApplicantIdCaseIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/change-password",
        "/delete-account",
        "/forgot-password",
        "/pricing",
        "/privacy-policy",
        "/reset-password",
        "/sign-in",
        "/sign-up",
        "/terms-of-service",
        "/client-portal/internal/sample",
        "/client-portal/public/$encodedCaseId",
        "/client-portal/eoir/internal/sample",
        "/client-portal/eoir/public/$encodedCaseId",
        "/client-portal/internal/$applicantId/$caseId",
        "/client-portal/eoir/internal/$applicantId/$caseId"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_dashboard",
        "/_app/import",
        "/_app/settings",
        "/_app/",
        "/_app/applicants/$applicantId",
        "/_app/cases-eoir/active",
        "/_app/cases-eoir/inactive",
        "/_app/cases/active",
        "/_app/cases/inactive",
        "/_app/applicants/",
        "/_app/cases/"
      ]
    },
    "/change-password": {
      "filePath": "change-password.tsx"
    },
    "/delete-account": {
      "filePath": "delete-account.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/pricing": {
      "filePath": "pricing.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/sign-in": {
      "filePath": "sign-in.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/terms-of-service": {
      "filePath": "terms-of-service.tsx"
    },
    "/_app/_dashboard": {
      "filePath": "_app._dashboard.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_dashboard/dashboard"
      ]
    },
    "/_app/import": {
      "filePath": "_app.import.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app.settings.tsx",
      "parent": "/_app"
    },
    "/_app/": {
      "filePath": "_app.index.tsx",
      "parent": "/_app"
    },
    "/_app/applicants/$applicantId": {
      "filePath": "_app.applicants.$applicantId.tsx",
      "parent": "/_app",
      "children": [
        "/_app/applicants/$applicantId/cases-eoir/$caseNumber",
        "/_app/applicants/$applicantId/cases/$caseNumber"
      ]
    },
    "/_app/cases-eoir/active": {
      "filePath": "_app.cases-eoir.active.tsx",
      "parent": "/_app"
    },
    "/_app/cases-eoir/inactive": {
      "filePath": "_app.cases-eoir.inactive.tsx",
      "parent": "/_app"
    },
    "/_app/cases/active": {
      "filePath": "_app.cases.active.tsx",
      "parent": "/_app"
    },
    "/_app/cases/inactive": {
      "filePath": "_app.cases.inactive.tsx",
      "parent": "/_app"
    },
    "/client-portal/internal/sample": {
      "filePath": "client-portal.internal.sample.tsx"
    },
    "/client-portal/public/$encodedCaseId": {
      "filePath": "client-portal.public.$encodedCaseId.tsx"
    },
    "/_app/applicants/": {
      "filePath": "_app.applicants.index.tsx",
      "parent": "/_app"
    },
    "/_app/cases/": {
      "filePath": "_app.cases.index.tsx",
      "parent": "/_app"
    },
    "/_app/_dashboard/dashboard": {
      "filePath": "/",
      "parent": "/_app/_dashboard",
      "children": [
        "/_app/_dashboard/dashboard/_caseUpdates",
        "/_app/_dashboard/dashboard/_taskManagement",
        "/_app/_dashboard/dashboard/case-analysis",
        "/_app/_dashboard/dashboard/general-info",
        "/_app/_dashboard/dashboard/"
      ]
    },
    "/_app/_dashboard/dashboard/_caseUpdates": {
      "filePath": "_app._dashboard.dashboard._caseUpdates.tsx",
      "parent": "/_app/_dashboard/dashboard",
      "children": [
        "/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-activity-history",
        "/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-update-history",
        "/_app/_dashboard/dashboard/_caseUpdates/case-updates/"
      ]
    },
    "/_app/_dashboard/dashboard/_taskManagement": {
      "filePath": "_app._dashboard.dashboard._taskManagement.tsx",
      "parent": "/_app/_dashboard/dashboard",
      "children": [
        "/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed",
        "/_app/_dashboard/dashboard/_taskManagement/task-management/action-required",
        "/_app/_dashboard/dashboard/_taskManagement/task-management/"
      ]
    },
    "/_app/_dashboard/dashboard/case-analysis": {
      "filePath": "_app._dashboard.dashboard.case-analysis.tsx",
      "parent": "/_app/_dashboard/dashboard"
    },
    "/_app/_dashboard/dashboard/general-info": {
      "filePath": "_app._dashboard.dashboard.general-info.tsx",
      "parent": "/_app/_dashboard/dashboard"
    },
    "/client-portal/eoir/internal/sample": {
      "filePath": "client-portal.eoir.internal.sample.tsx"
    },
    "/client-portal/eoir/public/$encodedCaseId": {
      "filePath": "client-portal.eoir.public.$encodedCaseId.tsx"
    },
    "/client-portal/internal/$applicantId/$caseId": {
      "filePath": "client-portal.internal.$applicantId.$caseId.tsx"
    },
    "/_app/_dashboard/dashboard/": {
      "filePath": "_app._dashboard.dashboard.index.tsx",
      "parent": "/_app/_dashboard/dashboard"
    },
    "/_app/applicants/$applicantId/cases-eoir/$caseNumber": {
      "filePath": "_app.applicants.$applicantId.cases-eoir.$caseNumber.tsx",
      "parent": "/_app/applicants/$applicantId"
    },
    "/_app/applicants/$applicantId/cases/$caseNumber": {
      "filePath": "_app.applicants.$applicantId.cases.$caseNumber.tsx",
      "parent": "/_app/applicants/$applicantId"
    },
    "/client-portal/eoir/internal/$applicantId/$caseId": {
      "filePath": "client-portal.eoir.internal.$applicantId.$caseId.tsx"
    },
    "/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-activity-history": {
      "filePath": "_app._dashboard.dashboard._caseUpdates.case-updates.case-activity-history.tsx",
      "parent": "/_app/_dashboard/dashboard/_caseUpdates"
    },
    "/_app/_dashboard/dashboard/_caseUpdates/case-updates/case-update-history": {
      "filePath": "_app._dashboard.dashboard._caseUpdates.case-updates.case-update-history.tsx",
      "parent": "/_app/_dashboard/dashboard/_caseUpdates"
    },
    "/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed": {
      "filePath": "_app._dashboard.dashboard._taskManagement.task-management.action-completed.tsx",
      "parent": "/_app/_dashboard/dashboard/_taskManagement"
    },
    "/_app/_dashboard/dashboard/_taskManagement/task-management/action-required": {
      "filePath": "_app._dashboard.dashboard._taskManagement.task-management.action-required.tsx",
      "parent": "/_app/_dashboard/dashboard/_taskManagement"
    },
    "/_app/_dashboard/dashboard/_caseUpdates/case-updates/": {
      "filePath": "_app._dashboard.dashboard._caseUpdates.case-updates.index.tsx",
      "parent": "/_app/_dashboard/dashboard/_caseUpdates"
    },
    "/_app/_dashboard/dashboard/_taskManagement/task-management/": {
      "filePath": "_app._dashboard.dashboard._taskManagement.task-management.index.tsx",
      "parent": "/_app/_dashboard/dashboard/_taskManagement"
    }
  }
}
ROUTE_MANIFEST_END */
